"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ErrorBoundary = _interopRequireDefault(require("./ErrorBoundary"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _ErrorBoundary.default;
exports.default = _default;